import axios from 'axios';

const CHECK_URL = document.domain.replace('.gsshop.com', '');
const APP_URL =
    'review' == CHECK_URL
        ? '//m.gsshop.com'
        : 'asreview' == CHECK_URL
        ? '//asm.gsshop.com'
        : 'atreview' == CHECK_URL
        ? '//atm.gsshop.com'
        : 'local' == CHECK_URL
        ? '//asm.gsshop.com'
        : '//asm.gsshop.com';

function create(url, options) {
    const instance = axios.create(Object.assign({ baseURL: url }, options));
    return instance;
}

const basic = create(APP_URL, { timeout: 5000, withCredentials: true });

const replaceOption = (str) => {
    return str.replace(/\//i, '뿗');
};

// options
async function getOptions(prdcd) {
    try {
        let options = {};
        const response = await basic.get(`/product/revw/gallery/prdOptions/${prdcd}`);
        if (response.data.prdOptionList) {
            let depth1 = [];
            let depth2 = [];
            let depth3 = [];
            let depth4 = [];
            await response.data.prdOptionList.forEach((d) => {
                if (d.prdAttrColor) {
                    options.depth1 = {};
                    options.depth1.title = '색상 선택';
                    depth1.push(replaceOption(d.prdAttrColor));
                }
                if (d.prdAttrSize) {
                    options.depth2 = {};
                    options.depth2.title = '사이즈 선택';
                    let tempDepth2 = {};
                    tempDepth2[replaceOption(d.prdAttrColor)] = replaceOption(d.prdAttrSize);
                    depth2.push(tempDepth2);
                }
                if (d.prdAttrStyle) {
                    options.depth3 = {};
                    options.depth3.title = '스타일 선택';
                    let tempDepth3 = {};
                    tempDepth3[replaceOption(d.prdAttrColor) + '뿗' + replaceOption(d.prdAttrSize)] = replaceOption(d.prdAttrStyle);
                    depth3.push(tempDepth3);
                }
                if (d.prdAttrGft) {
                    options.depth4 = {};
                    options.depth4.title = '별도구성 선택';
                    let tempDepth4 = {};
                    tempDepth4[replaceOption(d.prdAttrColor) + '뿗' + replaceOption(d.prdAttrSize) + '뿗' + replaceOption(d.prdAttrStyle)] = replaceOption(d.prdAttrGft);
                    depth4.push(tempDepth4);
                }
            });
            const reduce = (array) => {
                return array.reduce(function(a, b) {
                    if (JSON.stringify(a).indexOf(JSON.stringify(b)) < 0) a.push(b);
                    return a;
                }, []);
            };
            const merge = (depth1, depth2) => {
                let result = {};
                depth1.forEach((data1) => {
                    result[data1] = [];
                    [...reduce(depth2)].forEach((data2) => {
                        if (data2[data1]) {
                            result[data1].push(data2[data1]);
                        }
                    });
                });
                return result;
            };
            const merge2 = (prefix, depth1, depth2) => {
                let result = {};
                depth1.forEach((data1) => {
                    result[prefix + '뿗' + data1] = [];
                    [...reduce(depth2)].forEach((data2) => {
                        if (data2[prefix + '뿗' + data1]) {
                            result[prefix + '뿗' + data1].push(data2[prefix + '뿗' + data1]);
                        }
                    });
                });
                return result;
            };
            if (depth1.length) {
                options.depth1.items = [...new Set(depth1)];
            }
            if (depth2.length) {
                options.depth2.items = merge(options.depth1.items, depth2);
            }
            if (depth3.length) {
                options.depth1.items.forEach((data1) => {
                    options.depth3.items = {
                        ...options.depth3.items,
                        ...merge2(data1, options.depth2.items[data1], depth3),
                    };
                });
            }
            if (depth4.length) {
                options.depth1.items.forEach((data1) => {
                    options.depth2.items[data1].forEach((data2) => {
                        options.depth4.items = {
                            ...options.depth4.items,
                            ...merge2(data1 + '뿗' + data2, options.depth3.items[data1 + '뿗' + data2], depth4),
                        };
                    });
                });
            }
            // console.log("depth1", options.depth1.items);
            // console.log("depth2", options.depth2.items);
            // console.log("depth3", options.depth3.items);
            // console.log("depth4", options.depth4.items);
        }
        return options;
    } catch (error) {
        console.log(error);
        return error;
    }
}

// items
async function fetchItems(prdcd) {
    try {
        let data = {
            prdcd: 0,
            totalCnt: 0,
            loginYn: 'N',
            items: [],
        };
        const response = await basic.get(`/product/revw/gallery/list/${prdcd}`);
        data.appYn = response.data.appYn;
        data.prdcd = response.data.prdCd;
        data.totalCnt = response.data.allRevwTotCnt;
        data.loginYn = response.data.loginYn ? response.data.loginYn : 'N';
        if (response.data.prdRevwGalleryItems && response.data.prdRevwGalleryItems.prdRevwGalleryList) {
            data.items = await Promise.all(
                response.data.prdRevwGalleryItems.prdRevwGalleryList.map((item) => {
                    let result = {
                        messageId: item.prdrevwId,
                        stars: (item.prdrevwGrd / 100) * 5,
                        regDtm: item.regDtm.substr(0, 4) + '.' + item.regDtm.substr(4, 2) + '.' + item.regDtm.substr(6, 2),
                        regrId: item.regrId,
                        type: item.prdRevwAtachFile.atachFileType,
                        path: item.prdRevwAtachFile.atachFilePath,
                        thumbPath: item.prdRevwAtachFile.atachFileThumb,
                        exposNo: item.prdRevwAtachFile.exposNo,
                        revwTyp: item.revwTyp,
                        rcmdFlg: item.rcmdFlg,
                        rcmdCnt: item.rcmdCnt,
                        optNm: item.optNm,
                        evalInfoList: item.evalInfoList,
                        revwPrsn: item.revwPrsn, // prsnHgt(키), prsnUps(상의), prsnDws(하의)가 전부인지 확인
                        prdrevwBody: item.prdrevwBody,
                        myRevwFlg: item.myRevwFlg,
                    };
                    return result;
                })
            );
        }
        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
}

// items
async function fetchItemsWithOption(prdcd, optNm) {
    try {
        let data = {
            prdcd: 0,
            totalCnt: 0,
            items: [],
        };
        const response = await basic.get(`/product/revw/gallery/list/${prdcd}?$keyword=${optNm}`);
        data.prdcd = response.data.prdCd;
        data.totalCnt = response.data.allRevwTotCnt;
        if (response.data.prdRevwGalleryItems && response.data.prdRevwGalleryItems.prdRevwGalleryList) {
            data.items = await Promise.all(
                response.data.prdRevwGalleryItems.prdRevwGalleryList.map((item) => {
                    let result = {
                        messageId: item.prdrevwId,
                        stars: (item.prdrevwGrd / 100) * 5,
                        regDtm: item.regDtm.substr(0, 4) + '.' + item.regDtm.substr(4, 2) + '.' + item.regDtm.substr(6, 2),
                        regrId: item.regrId,
                        type: item.prdRevwAtachFile.atachFileType,
                        path: item.prdRevwAtachFile.atachFilePath,
                        thumbPath: item.prdRevwAtachFile.atachFileThumb,
                        exposNo: item.prdRevwAtachFile.exposNo,
                        revwTyp: item.revwTyp,
                        rcmdFlg: item.rcmdFlg,
                        rcmdCnt: item.rcmdCnt,
                        optNm: item.optNm,
                        evalInfoList: item.evalInfoList,
                        revwPrsn: item.revwPrsn, // prsnHgt(키), prsnUps(상의), prsnDws(하의)가 전부인지 확인
                        prdrevwBody: item.prdrevwBody,
                        myRevwFlg: item.myRevwFlg,
                    };
                    return result;
                })
            );
        }
        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
}

// more
async function moreItems(prdcd, messageId) {
    try {
        let items = [];
        const response = await basic.get(`/product/revw/gallery/list/${prdcd}?$messageId=${messageId}`);
        if (response.data.prdRevwGalleryItems) {
            items = await Promise.all(
                response.data.prdRevwGalleryItems.prdRevwGalleryList.map((item) => {
                    let result = {
                        messageId: item.prdrevwId,
                        stars: (item.prdrevwGrd / 100) * 5,
                        regDtm: item.regDtm.substr(0, 4) + '.' + item.regDtm.substr(4, 2) + '.' + item.regDtm.substr(6, 2),
                        regrId: item.regrId,
                        type: item.prdRevwAtachFile.atachFileType,
                        path: item.prdRevwAtachFile.atachFilePath,
                        thumbPath: item.prdRevwAtachFile.atachFileThumb,
                        exposNo: item.prdRevwAtachFile.exposNo,
                        revwTyp: item.revwTyp,
                        rcmdFlg: item.rcmdFlg,
                        rcmdCnt: item.rcmdCnt,
                        optNm: item.optNm,
                        evalInfoList: item.evalInfoList,
                        revwPrsn: item.revwPrsn, // prsnHgt(키), prsnUps(상의), prsnDws(하의)가 전부인지 확인
                        prdrevwBody: item.prdrevwBody,
                        myRevwFlg: item.myRevwFlg,
                    };
                    return result;
                })
            );
        }
        return items;
    } catch (error) {
        console.log(error);
        return error;
    }
}

// more
async function moreItemsWithOption(prdcd, messageId, optNm) {
    try {
        let items = [];
        const response = await basic.get(`/product/revw/gallery/list/${prdcd}?$messageId=${messageId}&$keyword=${optNm}`);
        if (response.data.prdRevwGalleryItems) {
            items = await Promise.all(
                response.data.prdRevwGalleryItems.prdRevwGalleryList.map((item) => {
                    let result = {
                        messageId: item.prdrevwId,
                        stars: (item.prdrevwGrd / 100) * 5,
                        regDtm: item.regDtm.substr(0, 4) + '.' + item.regDtm.substr(4, 2) + '.' + item.regDtm.substr(6, 2),
                        regrId: item.regrId,
                        type: item.prdRevwAtachFile.atachFileType,
                        path: item.prdRevwAtachFile.atachFilePath,
                        thumbPath: item.prdRevwAtachFile.atachFileThumb,
                        exposNo: item.prdRevwAtachFile.exposNo,
                        revwTyp: item.revwTyp,
                    };
                    return result;
                })
            );
        }
        return items;
    } catch (error) {
        console.log(error);
        return error;
    }
}

// detail
async function getItem(prdcd, messageId) {
    try {
        let item = {
            appYn: '',
            loginYn: '',
            retUrl: '',
            messageId: 0,
            stars: 0, // 별점
            regrId: '', // 작성자 ID
            regDtm: '',
            optNm: '',
            evalInfoList: [],
            revwPrsn: {},
            prdrevwBody: '',
            images: [],
            myRevwFlg: 'N',
            rcmdCnt: 0,
            rcmdFlg: 'N',
            oppstFlg: 'N',
            currIdx: 1,
        };
        const response = await basic.get(`/product/revw/gallery/detail/${prdcd}/${messageId}`);
        item.messageId = messageId;
        item.appYn = response.data.appYn;
        item.prdcd = prdcd;
        item.loginYn = response.data.loginYn;
        item.retUrl = response.data.retUrl;
        if (response.data.prdRevwGalleryItems && response.data.prdRevwGalleryItems.prdRevwGalleryList.length) {
            let data = response.data.prdRevwGalleryItems.prdRevwGalleryList[0];
            item.stars = (data.prdrevwGrd / 100) * 5;
            item.regrId = data.regrId;
            item.regDtm = data.regDtm.substr(0, 4) + '.' + data.regDtm.substr(4, 2) + '.' + data.regDtm.substr(6, 2);
            item.optNm = data.optNm;
            item.evalInfoList = data.evalInfoList;
            item.revwPrsn = data.revwPrsn; // prsnHgt(키), prsnUps(상의), prsnDws(하의)가 전부인지 확인
            item.prdrevwBody = data.prdrevwBody;
            data.revwImgVideoList.forEach((d) => {
                item.images.push({
                    type: d.atachFileType,
                    path: d.atachFilePath,
                    thumbPath: d.atachFileThumb,
                    exposNo: d.exposNo,
                });
            });
            item.myRevwFlg = data.myRevwFlg;
            if (data.rcmdCnt) {
                item.rcmdCnt = data.rcmdCnt;
            }
            item.rcmdFlg = data.rcmdFlg;
            item.oppstFlg = data.oppstFlg;
            item.revwTyp = data.revwTyp;
        }

        return item;
    } catch (error) {
        console.log(error);
        return error;
    }
}

// rcmdSubmit
async function submitRcmd(prdcd, messageId, myRevwFlg, rcmdFlg, oppstFlg) {
    if ('Y' == myRevwFlg) {
        alert('본인이 작성한 상품평은 평가할 수 없습니다.');
        return;
    }
    let saveTyp = 'Y' == rcmdFlg ? 'D' : 'I&mseq=415306';
    try {
        const response = await basic.get(`/knownew/estimate/prdRevwRcmdSave.gs?$prdCd=${prdcd}&prdrevwId=${messageId}&saveTyp=${saveTyp}&oppstFlg=${oppstFlg}`);
        if ('S' == response.data.retCd) {
            return 'Y' == rcmdFlg ? 'D' : 'I';
        } else if ('E' == response.data.retCd) {
            if ('직접 작성하신 상품평은 추천하실 수 없습니다.' == response.data.retMsg) {
                alert('본인이 작성한 상품평은 평가할 수 없습니다.');
                return;
            } else {
                alert(response.data.retMsg);
                return;
            }
        }
        return '';
    } catch (error) {
        console.log(error);
        return error;
    }
}

// reportOption
async function reportOption() {
    try {
        const response = await basic.get(`/product/revw/gallery/declrItmList`);
        return response.data.revwDeclrItmList;
    } catch (error) {
        console.log(error);
        return error;
    }
}

// reportSubmit
async function reportSubmit(messageId, code, content) {
    try {
        const check = await basic.get(`/knownew/estimate/productReviewReportCheck.gs?prdrevwId=${messageId}`);
        if (check.data.errorMsg) {
            alert(check.data.errorMsg);
            return;
        }
        const response = await basic.post(
            `/knownew/estimate/productRevwReportProcess.gs`,
            { prdrevwId: messageId, declrTyp: code, declrRsn: content },
            {
                headers: {
                    Origin: location.hostname, // Origin 헤더 추가
                },
            }
        );
        console.log(response);
        var reportResultMsg = '';
        if (response.data.procFlg == 'Y') {
            reportResultMsg = response.data.procMsg;
        } else {
            reportResultMsg = '잠시 후 다시 시도해주세요.';
        }
        alert(reportResultMsg);
        history.back();
        return;
    } catch (error) {
        console.log(error);
        return error;
    }
}

// reportCheck
async function reportCheck(messageId) {
    try {
        const check = await basic.get(`/knownew/estimate/productReviewReportCheck.gs?prdrevwId=${messageId}`);
        return check;
    } catch (error) {
        console.log(error);
        return error;
    }
}

export { APP_URL, reportCheck, getOptions, fetchItems, fetchItemsWithOption, moreItems, moreItemsWithOption, getItem, submitRcmd, reportOption, reportSubmit };
